import React, { createContext, useState, useEffect } from 'react';

import { getEnvironment } from 'helpers/environment';

const env = getEnvironment();

const ISLOGGEDIN_ENDPOINT = '/auth/isloggedin';

const loginUrl = env === 'local' ? 'http://localhost:2000/auth/login' : '/auth/login';
const fromUrl = env === 'local' ? 'http://localhost:3000' : window.location.href;
const STORAGE_KEY = 'sorteerpasopladen_initialLogin';

export const UserContext = createContext();

export const UserProvider = (props) => {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(
    () => {
      const fetchUser = async () => {
        if (loading || isLoggedIn) return;

        try {
          const response = await fetch(ISLOGGEDIN_ENDPOINT);
          const data = await response.json();
          const aprofiel = data?.user?.dataSources?.aprofiel;

          setIsLoggedIn(!!aprofiel);
          setUser(aprofiel);

          setLoading(false);
          if (!data.isLoggedin) {
            localStorage.setItem(STORAGE_KEY, true);
            return window.location.href = `${loginUrl}?fromUrl=${fromUrl}`;
          }
        } catch(err) {
          setError(err);
          setLoading(false);
        }
      }
      // because useEffect is sync
      fetchUser();
    },
    [],
  );
  return (
    <UserContext.Provider value={{
      loading,
      user,
      error,
      isLoggedIn,
    }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;
